import ExtendableError from './ExtendableError.js';
/** Thrown if the recursion limit is exceeded */
export default class RecursionLimitError extends ExtendableError {
    constructor(message = 'Recursion limit exceeded') {
        super(message);
    }
}
